<ag-grid-angular
	domLayout="autoHeight"
	class="ac-theme-ag-grid"
	[ngStyle]="gridStyle"
	noRowsOverlayComponent="noRowsOverlayComponent"
	[noRowsOverlayComponentParams]="{ icon: 'seek' }"
	[gridOptions]="gridOptions"
>
</ag-grid-angular>
